import styled from "styled-components";

export const Pagina404Container = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #001019 18.65%, #014e7a 86.55%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Pagina404Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 60px;
`;

export const Pagina404Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Pagina404Txt = styled.div`
  padding: 24px;
  text-align: center;
  max-width: 540px;
`;

export const Pagina404BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
  width: 50%;
`;

export const Pagina404Btn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: 8px;
`;
